module.exports = __webpack_public_path__ + "static/media/Huacho_256x256px.2227baed.jpg";